<template>
  <a-card :bordered="false">
    <div>
      <channel-search
        @wechatApp="init"
        :wechatType="this.wechatType"
      ></channel-search>
      <!-- 按钮区域 -->
      <div>
        <a-button @click="addOrUpdate()">新增标签</a-button>
        <a-button @click="syncTags()">标签同步</a-button>
        <a-button
          type="danger"
          :disabled="dataListSelections.length == 0"
          @click="deleteTagBatch"
          >批量删除</a-button
        >
      </div>
      <!-- 按钮区域END -->

      <!-- 表格区域 -->
      <div style="margin-top: 10px">
        <a-table
          ref="table"
          size="middle"
          rowKey="tagId"
          :columns="columns"
          :dataSource="tagList"
          class="j-table-force-nowrap"
          :row-selection="{
            selectedRowKeys: dataListSelections,
            onChange: onSelectChange
          }"
          :pagination="pagination"
          @change="handleTableChange"
        >
          <template slot="headimgurlslot" slot-scope="text, record, index">
            <div class="anty-img-wrap">
              <a-avatar
                shape="square"
                :src="getHeadImageView(record.headimgurl)"
                icon="user"
              />
            </div>
          </template>
          <template slot="sexslot" slot-scope="text, record, index">
            <span v-if="record.sex === 1">男</span>
            <span v-if="record.sex === 2">女</span>
            <span v-if="record.sex === 0">未知</span>
          </template>
          <template slot="tagslot" slot-scope="text, record, index">
            <span>{{ getTagName(record.tagidList) }}</span>
          </template>
          <span slot="action" slot-scope="text, record">
            <a
              style="margin-left: 10px"
              @click="addOrUpdate(record.id, record.tagId, record.tagName)"
              >编辑</a
            >
            <a style="margin-left: 10px" @click="tagUser(record.tagId)"
              >分配用户</a
            >
            <a style="margin-left: 10px" @click="unTagUser(record.tagId)"
              >删除用户</a
            >
            <a
              style="margin-left: 10px"
              @click="deleteTag(record.id, record.tagId)"
              >删除</a
            >
          </span>
        </a-table>
      </div>
      <!-- 表格区域END -->

      <!-- 新增修改modal -->
      <a-modal
        :title="!dataForm.tagId ? '新增标签' : '编辑标签'"
        :visible="visible"
        @cancel="handleCancel"
        @ok="handleOk"
      >
        <a-form-model
          layout="inline"
          :model="dataForm"
          :rules="dataRule"
          ref="dataForm"
        >
          <a-form-model-item label="标签名称" prop="tagName">
            <a-input v-model="dataForm.tagName"></a-input>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
      <!-- 新增修改modal END -->

      <!-- 用户信息列表modal -->
      <a-modal
        title="用户信息列表"
        :visible="userVisible"
        width="1000px"
        @cancel="userHandleCancel"
        @ok="userHandleOk"
      >
        <div>
          <a-form-model
            class="ant-advanced-search-form"
            :model="searchForm"
            layout="inline"
            ref="searchForm"
            @keyup.enter.native="handleSearch"
          >
            <a-form-model-item
              label="昵称"
              placeholder="请输入昵称"
              prop="nickName"
            >
              <a-input v-model="searchForm.nickName"></a-input>
            </a-form-model-item>
            <a-form-model-item label="性别" prop="sex">
              <a-select
                style="width: 120px"
                placeholder="请选择"
                v-model="searchForm.sex"
              >
                <a-select-option value="1">男</a-select-option>
                <a-select-option value="2">女</a-select-option>
                <a-select-option value="0">未知</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="关注时间">
              <a-range-picker :value="createValue" @change="createChange" />
            </a-form-model-item>
            <a-form-item label="地区" prop="area">
              <a-cascader
                v-model="searchForm.area"
                :field-names="{ label: 'name', value: 'name', children: 'sub' }"
                :options="areaOptions"
                placeholder="请选择地区"
                change-on-select
                @change="onChange"
              ></a-cascader>
            </a-form-item>
            <a-form-model-item>
              <a-button @click="reset">重置</a-button>
              <a-button type="primary" @click="handleSearch">搜索</a-button>
            </a-form-model-item>
          </a-form-model>
        </div>
        <a-table
          ref="table"
          size="middle"
          :rowKey="record => record.openid"
          :columns="column"
          :dataSource="userList"
          :row-selection="{
            selectedRowKeys: userDataListSelections,
            onChange: userOnSelectChange
          }"
          class="j-table-force-nowrap"
          :pagination="userPagination"
          @change="userHandleTableChange"
        >
          <template slot="headimgurlslot" slot-scope="text, record, index">
            <div class="anty-img-wrap">
              <a-avatar
                shape="square"
                :src="getHeadImageView(record.headimgurl)"
                icon="user"
              />
            </div>
          </template>
          <template slot="sexslot" slot-scope="text, record, index">
            <span v-if="record.sex === 1">男</span>
            <span v-if="record.sex === 2">女</span>
            <span v-if="record.sex === 0">未知</span>
          </template>
          <template slot="tagslot" slot-scope="text, record, index">
            <span>{{ getTagName(record.tagidList) }}</span>
          </template>
        </a-table>
      </a-modal>
      <!-- 新增修改modal END -->
    </div>
  </a-card>
</template>

<script>
import channelSearch from '@/components/wechat/channelSearch';
import { getAction, postAction, getFileAccessHttpUrl } from '@/api/manage';
import moment from 'moment';
import { areaList } from '@/utils/area';
export default {
  components: {
    channelSearch
  },
  data() {
    return {
      areaOptions: areaList,
      visible: false,
      userVisible: false,
      tagList: [],
      tagListAll: [],
      userList: [],
      wechatAppId: '',
      wechatAppType: '',
      wechatType: '1,2',
      createValue: [],
      dataListSelections: [],
      userDataListSelections: [],
      selectedRowKeys: [],
      inType: '',
      tagId: '',
      pageIndex: 1,
      pageSize: 4,
      pagination: {
        total: 0,
        pageSize: 4, //每页中显示10条数据
        showSizeChanger: false,
        pageSizeOptions: ['10', '20', '50', '100'], //每页中显示的数据
        showTotal: total => `共有 ${total} 条数据` //分页中显示总的数据
      },
      userPageIndex: 1,
      userPageSize: 4,
      userPagination: {
        total: 0,
        pageSize: 4, //每页中显示10条数据
        showSizeChanger: false,
        pageSizeOptions: ['10', '20', '50', '100'], //每页中显示的数据
        showTotal: total => `共有 ${total} 条数据` //分页中显示总的数据
      },
      searchForm: {
        nickName: '',
        sex: '',
        startTime: '',
        endTime: ''
      },
      dataForm: {
        id: '',
        tagId: '',
        appId: '',
        tagName: ''
      },
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          key: 'id'
        },
        {
          title: '标签ID',
          dataIndex: 'tagId',
          key: 'tagId'
        },
        {
          title: '标签名称',
          dataIndex: 'tagName',
          key: 'tagName'
        },
        {
          title: '同步时间',
          dataIndex: 'syncTime',
          key: 'syncTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          // fixed:"right",
          width: 147,
          scopedSlots: { customRender: 'action' }
        }
      ],
      column: [
        {
          title: 'openId',
          dataIndex: 'openid',
          align: 'center',
          key: 'openid'
        },
        {
          title: '昵称',
          dataIndex: 'nickname',
          align: 'center',
          key: 'nickname'
        },
        {
          title: '头像',
          dataIndex: 'headimgurl',
          align: 'center',
          key: 'headimgurl',
          width: 120,
          scopedSlots: { customRender: 'headimgurlslot' }
        },
        {
          title: '性别',
          dataIndex: 'sex',
          align: 'center',
          key: 'sex',
          scopedSlots: { customRender: 'sexslot' }
        },
        {
          title: '地区',
          dataIndex: 'city',
          align: 'center',
          key: 'city'
        },
        {
          title: '标签',
          dataIndex: 'tagidList',
          align: 'center',
          key: 'tagidList',
          scopedSlots: { customRender: 'tagslot' }
        },
        {
          title: '关注时间',
          dataIndex: 'subscribeTime',
          align: 'center',
          key: 'subscribeTime'
        }
      ],
      dataRule: {
        tagName: [
          { required: true, message: '标签名称不能为空', trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    init(data) {
      this.wechatAppId = data.appId;
      this.wechatAppType = data.type;
      this.getTagList();
      this.getTagListAll();
    },
    //地区选择
    onChange(checked) {
      if (checked.length == 3) {
        this.searchForm.city = checked[2];
        this.searchForm.province = checked[1];
      }
      if (checked.length == 2) {
        this.searchForm.province = checked[1];
      }
      this.searchForm.country = checked[0];
      console.log(`a-switch to ${checked}`);
    },
    getTagListAll() {
      getAction(process.env.VUE_APP_CMS_WECHAT + '/manage/wxUserTags/listAll', {
        appid: this.wechatAppId
      }).then(res => {
        if (res.success && res.code === 200) {
          this.tagListAll = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleTableChange(pagination) {
      const page = { ...this.pagination };
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.pageIndex = pagination.current;
      this.pageSize = pagination.pageSize;
      this.pagination = page;
      this.getTagList();
    },
    userHandleTableChange(pagination) {
      const page = { ...this.userPagination };
      this.userPagination.current = pagination.current;
      this.userPagination.pageSize = pagination.pageSize;
      this.userPageIndex = pagination.current;
      this.userPageSize = pagination.pageSize;
      this.userPagination = page;
      this.getDataList(this.tagId, this.inType);
    },
    syncTags() {
      if (!this.wechatAppId) {
        this.$message.warning('请选择渠道');
      } else {
        postAction(
          process.env.VUE_APP_CMS_WECHAT + '/manage/wxUserTags/syncTags',
          {
            appId: this.wechatAppId
          }
        ).then(res => {
          if (res.success && res.code === 200) {
            this.$message.success('同步任务已建立，请稍候刷新查看列表');
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    tagUser(tagId) {
      this.userVisible = true;
      this.userDataListSelections = [];
      this.inType = 'notIn';
      this.tagId = tagId;
      this.getDataList(tagId, this.inType);
    },
    unTagUser(tagId) {
      this.userVisible = true;
      this.userDataListSelections = [];
      this.inType = 'in';
      this.tagId = tagId;
      this.getDataList(tagId, this.inType);
    },
    reset() {
      this.$refs.searchForm.resetFields();
      this.searchForm = {};
      this.createValue = [];
    },
    createChange(dates, dateStrings) {
      this.createValue = dates;
      this.searchForm.beginTime = dateStrings[0];
      this.searchForm.endTime = dateStrings[1];
    },
    handleSearch(e) {
      let data = JSON.parse(JSON.stringify(this.searchForm));
      console.log(data);
      this.getDataList(this.tagId, this.inType);
    },
    addOrUpdate(id, tagId, name) {
      if (!this.wechatAppId) {
        this.$message.warning('请选择渠道');
      } else {
        if (!id) {
          this.dataForm.id = '';
          this.dataForm.tagId = '';
          this.dataForm.tagName = '';
        } else {
          this.dataForm.id = id;
          this.dataForm.tagId = tagId;
          this.dataForm.tagName = name;
        }
        this.visible = true;
      }
    },
    deleteTag(id, tagId) {
      postAction(process.env.VUE_APP_CMS_WECHAT + '/manage/wxUserTags/delete', {
        appId: this.wechatAppId,
        tagId: tagId,
        id: id
      }).then(res => {
        if (res.success && res.code === 200) {
          this.$message.success('删除成功');
          this.getTagList();
        } else {
          this.$message.error(res.message, 10);
        }
      });
    },
    deleteTagBatch() {
      const ids = this.dataListSelections.toString();
      postAction(
        process.env.VUE_APP_CMS_WECHAT + '/manage/wxUserTags/deleteBatch',
        {
          appId: this.wechatAppId,
          ids: ids
        }
      ).then(res => {
        if (res.success && res.code === 200) {
          this.$message.success('删除成功');
          this.getTagList();
        } else {
          this.$message.error(res.message, 10);
        }
      });
    },
    dataFormSubmit() {
      this.dataForm.appId = this.wechatAppId;
      let data = JSON.parse(JSON.stringify(this.dataForm));
      postAction(
        process.env.VUE_APP_CMS_WECHAT + '/manage/wxUserTags/save',
        data
      ).then(res => {
        if (res.success && res.code === 200) {
          if (!data.id) {
            this.$message.success('新增成功');
          } else {
            this.$message.success('更新成功');
          }
          this.visible = false;
          this.getTagList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleOk(e) {
      this.dataFormSubmit();
    },
    handleCancel(e) {
      this.$refs.dataForm.resetFields();
      this.visible = false;
    },
    userHandleOk(e) {
      postAction(
        process.env.VUE_APP_CMS_WECHAT +
          `/manage/wxUserTags/${
            this.inType == 'in' ? 'batchUnTagging' : 'batchTagging'
          }`,
        {
          appid: this.wechatAppId,
          tagId: this.tagId,
          openIds: this.userDataListSelections.join(',')
        }
      ).then(res => {
        if (res.success && res.code === 200) {
          this.$message.success(res.message);
        } else {
          this.$message.warning(res.message);
        }
        this.userDataListSelections = [];
        this.userVisible = false;
      });
    },
    userHandleCancel(e) {
      this.$refs.searchForm.resetFields();
      this.userDataListSelections = [];
      this.userVisible = false;
    },
    onSelectChange(selectedRowKeys) {
      this.dataListSelections = selectedRowKeys;
      console.log(this.dataListSelections);
    },
    userOnSelectChange(selectedRowKeys) {
      this.userDataListSelections = selectedRowKeys;
      console.log(this.userDataListSelections);
    },
    getHeadImageView: function(headimgurl) {
      return getFileAccessHttpUrl(headimgurl);
    },
    //获取标签列表
    getTagList() {
      getAction(process.env.VUE_APP_CMS_WECHAT + '/manage/wxUserTags/list', {
        appid: this.wechatAppId,
        pageNo: this.pageIndex,
        pageSize: this.pageSize
      }).then(res => {
        if (res.success && res.code === 200) {
          this.tagList = res.result.records;
          this.pagination.total = res.result.total;
        } else {
          this.tagList = [];
          this.totalCount = 0;
          this.$message.error(res.message);
        }
      });
    },
    // 获取用户数据列表
    getDataList(tagId, inType) {
      getAction(process.env.VUE_APP_CMS_WECHAT + '/wxUser/listByTagId', {
        appId: this.wechatAppId,
        tagId: tagId,
        inType: inType,
        pageNo: this.userPageIndex,
        pageSize: this.userPageSize,
        ...this.searchForm
      }).then(res => {
        if (res.success && res.code === 200) {
          this.userList = res.result.records;
          this.userPagination.total = res.result.total;
        } else {
          this.userList = [];
        }
        //this.dataListLoading = false
      });
    },
    //标签名称
    getTagName(tagidList) {
      let userTag = tagidList
        .split('[')[1]
        .split(']')[0]
        .split(',');
      let userTagContent = '';
      for (let i in userTag) {
        for (let j in this.tagListAll) {
          if (userTag[i] == this.tagListAll[j].id) {
            userTagContent += this.tagListAll[j].name + ',';
          }
        }
      }
      if (userTagContent.length > 0) {
        userTagContent = userTagContent.substr(0, userTagContent.length - 1);
      }
      return userTagContent;
    }
  }
};
</script>
<style lang="less" scoped>
//@import '~@assets/less/common.less'
/** Button按钮间距 */
.ant-btn {
  margin-left: 10px;
}
.ant-btn-danger {
  color: #fff;
  background-color: #ff4d4f;
  border-color: #ff4d4f;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}
</style>
